module.exports = __webpack_public_path__ + "static/womanwall-17f61afe430d99f18859a08b816e47ff.jpg";